
export class PlumbingObject {
    public id: number;
    public name: string;
    public isClogged: boolean;
    // Frame name for the "clogged" or "broken" asset
    public cloggedFrame: string;
    // Frame nam efor the "unclogged" or "fixed" asset
    public fixedFrame: string;
    public toolName: string;
    // Corresponding zone id from TileMap (used to update the pipe's flow)
    public zoneID: number;
    public object?: Phaser.GameObjects.Sprite;
    // ID's of the other plumbing objects this one depends on (they must be unclogged before this one)
    public dependentOn?: number[];

    constructor(id: number, name: string, cloggedFrame: string, fixedFrame: string, zoneId: number, dependentOn: string[]) {
        this.id = id;
        this.name = name;
        this.cloggedFrame = cloggedFrame;
        this.fixedFrame = fixedFrame;
        this.isClogged = true;
        this.zoneID = zoneId;
        this.dependentOn = [];

        if(dependentOn[0] !== "none") {
            dependentOn.forEach((s: string) => {
                this.dependentOn.push(parseInt(s));
            });
        }

        // Can change the correct tool to be used to fix the object (currently not using blowtorch or tape for anything)
        if(this.name === "toilet") {
            this.toolName = "plunger";
        }
        else if(this.name === "tub" || this.name === "sink") {
            this.toolName = "wrench";
        }
    }

}



// WEBPACK FOOTER //
// ./src/games/PlumbingGame/objects/PlumbingObject.ts